import { useContext } from 'react';
import { useRecoilValue } from 'recoil';
import { SocketContext } from '@/contexts/socket';
import { sessionIdSelector } from '@/state/session';
import { SocketEvent } from '@/ts/socket';
export const useFileDownload = () => {
    const socket = useContext(SocketContext);
    const session_id = useRecoilValue(sessionIdSelector);
    const handleFileDownload = (file_id, file_name, original_name) => {
        if (socket && socket.connected) {
            // We use Promise.resolve().then() to defer the emit to the next microtask.
            // This ensures the Socket.IO client has fully stabilized the connection,
            // preventing the event from being marked as 'volatile'.
            Promise.resolve().then(() => {
                socket.emit(SocketEvent.session_files_download_request, {
                    file_id,
                    file_name,
                    session_id,
                    original_name,
                });
            });
        }
    };
    return { handleFileDownload };
};
